module.exports = require("node:events");